var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.9 47.9",
    style: {
      enableBackground: "new 0 0 47.9 47.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.9,19.4c-5.7,0-10.9,2.9-13.9,7.7c-0.7,1.2-0.4,2.7,0.8,3.4c1.2,0.7,2.7,0.4,3.4-0.8 c2.1-3.4,5.7-5.4,9.6-5.4s7.5,2,9.6,5.4c0.5,0.8,1.3,1.2,2.1,1.2c0.5,0,0.9-0.1,1.3-0.4c1.2-0.7,1.5-2.3,0.8-3.4 C34.8,22.3,29.6,19.4,23.9,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5,21.1C42.4,12.9,33.6,8,23.9,8S5.5,12.9,0.4,21.1c-0.7,1.2-0.4,2.7,0.8,3.4c1.2,0.7,2.7,0.4,3.4-0.8 C8.8,17,16,13,23.9,13S39,17,43.2,23.7c0.5,0.8,1.3,1.2,2.1,1.2c0.5,0,0.9-0.1,1.3-0.4C47.9,23.8,48.2,22.2,47.5,21.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.9,
    cy: 35.7,
    r: 4.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.079774bc0c8dfd3d49fe81918508c7c0.svg";
export { ForwardRef as ReactComponent };